/**
 * <cart-shipping-timer>
 * Nedtælling til dagens cutoff i kurv-drawer'en.
 *
 * HVORFOR ET CUSTOM ELEMENT?
 * Kurv-drawer'en genindlæses med `el.innerHTML = ...`
 * (se assets/cart-drawer.js → renderContents). Browsere kører IKKE
 * <script>-tags der indsættes via innerHTML, så den inline timer-kode der
 * før lå i snippets/cart-shipping-timer.liquid var død efter en
 * kurv-opdatering — markup'en kom frem, men cifrene blev stående på "--".
 * Det ramte især når kurven var tom og man lagde noget i: da går hele
 * drawer'en gennem renderContents-stien.
 *
 * Custom elements bliver derimod opgraderet automatisk når de indsættes i
 * DOM'en, så connectedCallback() kører hver gang — også efter innerHTML.
 * Definitionen indlæses én gang pr. sidevisning fra sections/cart-drawer.liquid.
 */
if (!customElements.get('cart-shipping-timer')) {
  class CartShippingTimer extends HTMLElement {
    connectedCallback() {
      this.cutoffHour = parseInt(this.dataset.cutoffH, 10);
      this.cutoffMinute = parseInt(this.dataset.cutoffM, 10);
      if (Number.isNaN(this.cutoffHour) || Number.isNaN(this.cutoffMinute)) return;

      this.boxHours = this.querySelector('[data-st-hours]');
      this.boxMinutes = this.querySelector('[data-st-minutes]');
      this.boxSeconds = this.querySelector('[data-st-seconds]');
      if (!this.boxHours || !this.boxMinutes || !this.boxSeconds) return;

      this.update();
      this.stop();
      this.ticker = setInterval(this.update.bind(this), 1000);
    }

    disconnectedCallback() {
      this.stop();
    }

    /**
     * Stopper nedtællingen. Kaldes når elementet fjernes fra DOM'en, så der
     * ikke hober sig intervaller op ved gentagne kurv-opdateringer.
     */
    stop() {
      if (this.ticker) {
        clearInterval(this.ticker);
        this.ticker = null;
      }
    }

    /**
     * @param {number} value - Tal der skal vises tocifret.
     * @returns {string}
     */
    static pad(value) {
      return String(value).padStart(2, '0');
    }

    /**
     * Opdaterer cifrene. Skjuler blokken når cutoff er passeret.
     */
    update() {
      const target = new Date();
      target.setHours(this.cutoffHour, this.cutoffMinute, 0, 0);
      const diff = target - new Date();

      if (diff <= 0) {
        this.stop();
        this.style.display = 'none';
        return;
      }

      this.boxHours.textContent = CartShippingTimer.pad(Math.floor(diff / 3600000));
      this.boxMinutes.textContent = CartShippingTimer.pad(Math.floor((diff % 3600000) / 60000));
      this.boxSeconds.textContent = CartShippingTimer.pad(Math.floor((diff % 60000) / 1000));
    }
  }

  customElements.define('cart-shipping-timer', CartShippingTimer);
}
